export default __webpack_public_path__ + "static/0178-128e40f5ab08f2a2709743670147c7a2.png";